module.exports = __webpack_public_path__ + "static/kumadex-jlpt-n2-25-words-73fcd168ba9229e276716f6c88d6c39d.png";